"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var deriveCustomTypeInstance = function (_a) {
    var constructor = _a.constructor;
    if (typeof constructor === 'function' && constructor !== Object) {
        return new constructor();
    }
    return {};
};
exports.default = deriveCustomTypeInstance;
//# sourceMappingURL=deriveCustomTypeInstance.js.map